import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { filterType } from '../constants/common';

export const savedFiltersKey = () => 'savedFilters';

const getSavedFilters = async () => {
  const res = await request.get(
    '/Filter',
    { type: filterType },
    'Не удалось получить сохраненные фильтры',
    []
  );
  return res
    .sort((a, b) => a.name - b.name)
    .map((data) => ({ ...data, filter: JSON.parse(data.filter) }));
};

const useSavedFilters = (options) =>
  useQuery(savedFiltersKey(), getSavedFilters, {
    placeholderData: [],
    ...options,
  });

export default useSavedFilters;
